import { render, staticRenderFns } from "./YoshlarBizning.vue?vue&type=template&id=13ba1de9&scoped=true&"
import script from "./YoshlarBizning.vue?vue&type=script&lang=js&"
export * from "./YoshlarBizning.vue?vue&type=script&lang=js&"
import style0 from "./YoshlarBizning.vue?vue&type=style&index=0&id=13ba1de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba1de9",
  null
  
)

export default component.exports